/* eslint-disable prettier/prettier */
import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import Axios from 'assets/remote/axios';
import {
    GET_AREAS,
    GET_QUESTIONS,
} from '../actions';
import {
    areas,
    questions,
} from './actions';
import { delay, errorHandler } from 'helpers/Utils';

export function* watchGetQuestions() {
    // eslint-disable-next-line no-use-before-define
    yield takeLatest(GET_QUESTIONS, getMukebs);
}
const getQuestionsAsync = async (filter) => {
    const r = await Axios.get('/questions', { filter });
    return r?.data;
}
function* getMukebs({ payload }) {
    const { filter } = payload;
    try {
        const response = yield call(getQuestionsAsync, filter);
        yield put(questions(response));
    } catch (error) {
        yield call(errorHandler, error);
    }
}

export function* watchGetAreas() {
    // eslint-disable-next-line no-use-before-define
    yield takeLatest(GET_AREAS, getAreas);
}
const getAreasAsync = async (filter) => {
    const r = await Axios.get('/areas', { filter });
    return r?.data;
}
function* getAreas({ payload }) {
    const { filter } = payload;
    try {
        const response = yield call(getAreasAsync, filter);
        yield put(areas(response));
    } catch (error) {
        yield call(errorHandler, error);
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchGetQuestions),
        fork(watchGetAreas),
    ]);
}
